// This is a temporary script that migrates the store on mobile.
export async function maybeMigrateMobileStorageAsync() {
  // On desktop, this is a noop, so do nothing.
}

// This is a temporary script that migrates the local prefs from strings to mpack
export async function maybeMigrateToMpackStorageAsync() {
  // On desktop, this is a noop, so do nothing.
}
